import api from "../../config/apiConfig";

const getAllPMS = async (data: any) => {
  // // console.logF Service', accessToken);
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post("/pms/getAll", data, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response.data.data;
};

const mfService = { getAllPMS };
export default mfService;
